import * as React from 'react';
import { observer } from 'mobx-react-lite';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

const styles = require('./GroupPicture.scss');

export interface GroupPictureProps {
    name: string;
    emailAddress: string;
    clientScenario: string;
    size: PersonaSize;
}

const GroupPicture = observer(function GroupPicture(props: GroupPictureProps) {
    const personaProps = {
        name: props.name,
        emailAddress: props.emailAddress,
        personaType: 'Group',
        clientScenario: props.clientScenario,
        size: props.size,
    };
    return <GroupPicturePersona {...personaProps} />;
});
export default GroupPicture;

export interface GroupPicturePersonaProps extends PersonaCardBehaviorProps {
    size: PersonaSize;
}

function GroupPicturePersona(props: GroupPicturePersonaProps) {
    const PersonaCardBehavior = useLivePersonaCard(props);
    return (
        <PersonaCardBehavior>
            <div data-is-focusable={true}>
                <PersonaControl
                    className={styles.groupPicture}
                    name={props.name}
                    emailAddress={props.emailAddress}
                    size={props.size}
                    mailboxType={props.mailBoxType}
                />
            </div>
        </PersonaCardBehavior>
    );
}
